<template>
  
    <div id="area-logada-pesquisa" :style="(mobile?'height:fit-content;':'')">
        <h1 id="area-logada-pesquisa-title">{{title}}</h1>
        <filtro v-if="hasFilter" :page="page" @filtroBusca="getFiltroBusca" @exportarBusca="exportarBusca" ref="filtroComponent" @setHeight="getFiltroOffsetHeight" @limparFiltro="limparFiltro"/>
        <filtrosAtivos v-if="hasFilter" :page="page" :filtros="filtros" :key="'filtros_key_' + setFilterList" @removeFilter="getRemovedFilter" ref="filtrosAtivosComponent" @setHeight="getFiltrosAtivosOffsetHeight"/>
        <resultado v-if="resultado.length > 0 && !mobile" class="d-none d-xl-block" :colunas="colunas" :resultado="resultado" :page="page" :title="title" :offsetHeight="offsetHeightResult" :key="'result_key_' + setResult" @chamar-funcao="chamarFuncao"/>
        <resultadomobile v-if="resultado.length > 0 && mobile" class="d-xl-none" :colunas="colunasMobile" :resultado="resultado" :page="page" :title="title" :offsetHeight="offsetHeightResult" :key="'resultMobile_key_' + setResultMobile"/>
    </div>
</template>
<script>
    import filtro from "@/components/arealogada/pesquisa/filtro/index.vue";
    import filtrosAtivos from "@/components/arealogada/pesquisa/filtro/ativos.vue";
    import resultado from "@/components/arealogada/pesquisa/resultado/index.vue";
    import resultadomobile from "@/components/arealogada/pesquisa/resultado/mobile.vue";

    export default {
        components: {
            filtro,
            resultado,
            resultadomobile,
            filtrosAtivos
        },
        props:{
            resultado:{type: Array, default: []},
            colunas:{type: Array, default: []},
            colunasMobile:{type: Array, default: []},
            hasFilter:{type: Boolean},
            page:{type: String},
            title:{type: String},
            // filterFields:[]
        },
        data() {
            return {
                // colunasMobile:[
                //     { key: "nm_nr_titulo", label: "Nº Título", sortable: false, size:"0.75fr"},
                //     { key: "nm_devedor", label: "Devedor", sortable: false, size:"1.5fr"},
                //     { key: "actions", label: "Exibir", sortable: false, size:"0.5fr"},
                // ],
                formData:[],
                filtros:{},
                setFilterList:0,
                setResult:0,
                setResultMobile:10,
                offsetHeights:{
                    title:'',
                    filtroComponent:'',
                    filtrosAtivosComponent:'',
                },
                mobile: window.innerWidth < 1200,
            }
        },
        methods: {
            exportarBusca(value){
                this.setFilterList++;
                this.filtros = value;
                this.$emit('exportarBusca', this.filtros);
            },
            getFiltroBusca(value){
                this.setFilterList++;
                this.filtros = value;
                this.$emit('filtrarBusca', this.filtros);
            },
            getRemovedFilter(value){
                delete this.filtros[value];
                this.$refs.filtroComponent.removeFilter(value);
            },
            getFiltroOffsetHeight(value){
                this.offsetHeights.filtroComponent = value;
            },
            getFiltrosAtivosOffsetHeight(value){
                this.offsetHeights.filtrosAtivosComponent = value;
            },
            limparFiltro(value){
                this.filtros = {};
                this.$refs.filtrosAtivosComponent.limparFiltro();
                this.setFilterList++;
                this.getFiltroBusca(value);
            },
            chamarFuncao(funcao, linha){
                this.$emit('chamar-funcao', funcao, linha)
            },
        },
        computed:{
            offsetHeightResult:{
                get(){
                    let resultadoHeightOffset = 'calc(100% - ';
                    let offsetHeight = this.offsetHeights.title + this.offsetHeights.filtroComponent + this.offsetHeights.filtrosAtivosComponent;
                    resultadoHeightOffset += offsetHeight + 'px)';
                    this.setResult++;
                    this.setResultMobile++;
                    return resultadoHeightOffset;
                }
            },
        },
        mounted() {
            let titleElement = document.getElementById('area-logada-pesquisa-title');
            if(titleElement !== null && titleElement !== undefined) {
                let titleStyle = titleElement.currentStyle || window.getComputedStyle(titleElement);
                this.offsetHeights.title = Number(titleElement.offsetHeight) + Number(titleStyle.marginBottom.replace(/[\D]+/g, ""));
            }
        }
    }
</script>
<style>
    h1 {text-align: left;font: normal normal 200 50px/55px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--secondary-color);margin-bottom: 22px;}
    #area-logada-pesquisa{height: calc(100vh - 80px - 36px - 37px - 78px);display: flex;flex-flow: column;overflow: auto;scrollbar-width: none;}
    #area-logada-pesquisa::-webkit-scrollbar{display: none;}
    @media (max-width:1199px){
        #area-logada-pesquisa{padding:0;}
    }
    .table-resultado-body .table-resultado-row .table-resultado-detail.container-actions{
        width: 100% !important;
        height: 100%;
        /* display: block ruby !important; */
    }
</style>
    